import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'fileUploadProgress',
    `
		max-width: 320px;
	`
  ]
]);
